




















































































































import EmailUs from '@/components/common/EmailUs.vue';
import QuoteQuery from '@/graphql/queries/quote.gql';
import request from '@/graphql/request';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    EmailUs,
  },
})
export default class Quote extends Vue {
  public id!: string;
  public isNotAccepted: boolean = true;
  public quote: {
    id: string;
    price: number;
    isAccepted: boolean;
    state: string;
    additionalTravelers: number;
    clinic: {
      id: string;
      name: string;
      location: {
        name: string;
      };
    };
    procedures: Array<{
      price: number;
      quantity: number;
      procedure: {
        name: string;
      };
    }>;
    flights?: Array<{
      price: number;
      name: string;
      departureDateTime: Date;
      departureAirport: string;
      arrivalDateTime: Date;
      arrivalAirport: string;
      stops: number;
      arrivalEstimate: string;
      departureEstimate: string;
    }>;
    reservation?: {
      price: number;
      beds: number;
      checkInDate: string;
      checkOutDate: string;
      hotel: {
        location: {
          city: string;
        };
        rating: number;
      };
    };
    expenses?: Array<{
      name: string;
      description: string;
      price: number;
    }>;
  } = {} as any;

  public mounted() {
    this.id = this.$route.query.id;

    request(QuoteQuery, { id: this.id })
      .then(response => {
        if (!response || !response.data) {
          console.error('No clinic returned');
          return;
        }

        this.quote = response.data.quote;

        if (!this.quote) {
          this.$router.push('/');
        }

        if (this.quote.state !== 'accepted') {
          this.isNotAccepted = true;
        }
        console.dir(this.quote);
      })
      .catch(console.error);
  }

  public procedureTotal() {
    return this.quote.procedures.reduce(
      (total, p) => p.price * p.quantity + total,
      0
    );
  }

  public flightTotal() {
    return this.quote.flights != null
      ? this.quote.flights.reduce((total, f) => f.price + total, 0)
      : 0;
  }

  public hotelTotal() {
    return this.quote.reservation != null ? this.quote.reservation.price : 0;
  }

  public miscellaneousTotal() {
    return this.quote.expenses != null
      ? this.quote.expenses.reduce((total, e) => e.price + total, 0)
      : 0;
  }

  public formatPrice(price: number) {
    return (price / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  public formatDate(date: string | Date) {
    return new Date(date).toLocaleDateString(undefined, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }
}
